import React, { useState } from "react";
import HeaderTitle from "../Auditon-comp/HeaderTitle";
import swal from "sweetalert";
function AuditionIncrementDecrement({ btn1, btn2, btn3, handleOnClick }) {
  const [value, setValue] = useState(0);
  const [count, setCount] = useState(1);
  function increment() {
    setCount(function (prevCount) {
      if (prevCount < 100) {
        return (prevCount += 1);
      } else {
        return (prevCount = 100);
      }
    });
  }
  function decrement() {
    setCount(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1);
      } else {
        return (prevCount = 0);
      }
    });
  }

  const handleCountChange = (e) => {
    if (e.target.value > 100 || e.target.value < 0) {
      swal(
        "Opps...",
        "Sorry input field should not more then 100 & short then 0",
        "error"
      );
      setCount(1);
    } else {
      setCount(Number(e.target.value));
    }
  };

  return (
    <>
      <HeaderTitle title={btn2} />

      <div className="row mx-1 mt-3 card-bg justify-content-center py-4">
        <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
          <div className="card-bg px-3">
            <b className="text-light">{btn1}</b>
          </div>
        </div>
        <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
          <div className="d-flex card-bg px-3 justify-content-around">
            <button onClick={decrement} className="btn btnDecrement bold">
              <i class="fa-solid fa-minus"></i>
            </button>
            <input
              type="number"
              value={count}
              onChange={(e) => handleCountChange(e)}
              className="text-center border-0 from-control bg-black fw-bold btnInput"
            />
            <button onClick={increment} className="btn btnIncrement bold">
              <i class="fa-solid fa-plus"></i>
            </button>
          </div>
        </div>
        <div className="col-md-4 card-bg card mb-2 border-0 rounded-0">
          <div className="card-bg px-3">
            <b className="text-light">{btn3}</b>
          </div>
        </div>
        <center className="col-md-4 mt-3 border-0 rounded-0">
          <div className="px-3">
            <button
              onClick={() => handleOnClick(count)}
              className="btn btnCreate fw-bold "
            >
              Get Result
            </button>
          </div>
        </center>
      </div>
    </>
  );
}

export default AuditionIncrementDecrement;
